import React from 'react';

const Icon = () => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none">
    <rect x="-6.10352e-05" y="0.5" width="32" height="32" rx="16" fill="black" fillOpacity="0.04" />
    <g clipPath="url(#clip0_2613_67281)">
      <path
        d="M23.4999 9L8.49994 15.275V16.0917L14.1999 18.3L16.3999 24H17.2166L23.4999 9Z"
        fill="#502314"
      />
    </g>
    <defs>
      <clipPath id="clip0_2613_67281">
        <rect width="20" height="20" fill="white" transform="translate(5.99994 6.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const LocationIcon = Icon;
